export const HOURS: number = 0;
export const MINUTES: number = 0;
export const SECONDS: number = 0;
export const MS: number = 0;

export const ADDITIONAL_MINUTE: number = 1;
export const ADDITIONAL_MONTH: number = 1;

export const SUMMARY_MIN_MONTH_INDEX: number = 6;
export const SUMMARY_MIN_DAY: number = 1;
export const SUMMARY_MAX_MONTH_INDEX: number = 7;
export const SUMMARY_MAX_DAY: number = 31;

export const TWENTY_ONE_YEARS_AGO_COUNT: number = 21;
export const TWO_YEARS_AGO_COUNT: number = 2;

export const MINUS_ONE_YEAR: number = 1;

// Additional Years
export const ADDITIONAL_YEAR: number = 1;
export const ADDITIONAL_TWO_YEARS: number = 2;
